import { UnfoldMoreHorizontalIcon } from './UnfoldMoreHorizontalIcon';

/**
 * author: Google
 * id E85F4170-11D3-4757-8247-17EBD07A08D4
 * name unfold-more-horizontal
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/unfold-more-horizontal.svg
 * tags
 */
export const ChevronUpDownIcon = UnfoldMoreHorizontalIcon;
export default ChevronUpDownIcon